import { render, staticRenderFns } from "./tags-sections-detail.vue?vue&type=template&id=c8881b54&"
import script from "./tags-sections-detail.vue?vue&type=script&lang=js&"
export * from "./tags-sections-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/django/skokka/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c8881b54')) {
      api.createRecord('c8881b54', component.options)
    } else {
      api.reload('c8881b54', component.options)
    }
    module.hot.accept("./tags-sections-detail.vue?vue&type=template&id=c8881b54&", function () {
      api.rerender('c8881b54', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/static/js/components/post/tags-sections-detail.vue"
export default component.exports